'use strict';

var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
require('prop-types');
var _Map = require('../../HousecallComponents/Map/Map.js');
var withGoogleMapsAPI = require('../../utils/withGoogleMapsAPI.js');
var Marker = require('../../HousecallComponents/Map/Marker.js');
var Polygon = require('../../HousecallComponents/Map/Polygon.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _dec, _dec2, _class;

var styles = function styles(theme) {
  return {
    map: {
      height: 300
    }
  };
};

var ServiceAreaMap = (_dec = withStyles(styles), _dec2 = withGoogleMapsAPI.withGoogleMapsAPI(), _dec(_class = _dec2(_class =
/*#__PURE__*/
function (_PureComponent) {
  inherits(ServiceAreaMap, _PureComponent);

  function ServiceAreaMap() {
    classCallCheck(this, ServiceAreaMap);

    return possibleConstructorReturn(this, getPrototypeOf(ServiceAreaMap).apply(this, arguments));
  }

  createClass(ServiceAreaMap, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          latitude = _this$props.latitude,
          longitude = _this$props.longitude,
          radius = _this$props.radius,
          polygon = _this$props.polygon,
          resetPolygonShape = _this$props.resetPolygonShape,
          onPolygonEdit = _this$props.onPolygonEdit,
          onRadiusChange = _this$props.onRadiusChange,
          onResetPolygonShape = _this$props.onResetPolygonShape;

      if (latitude !== prevProps.latitude || longitude !== prevProps.longitude) {
        Marker.resetMarker(latitude, longitude);
      }

      if (radius !== prevProps.radius) {
        Polygon.resetPolygon(latitude, longitude, radius, function () {
          return onPolygonEdit(Polygon.getPolygonCoordinates());
        });
        onRadiusChange(Polygon.getPolygonCoordinates());
      }

      if (resetPolygonShape && resetPolygonShape !== prevProps.resetPolygonShape) {
        Polygon.resetPolygon(latitude, longitude, radius, function () {
          return onPolygonEdit(Polygon.getPolygonCoordinates());
        });
        onResetPolygonShape(Polygon.getPolygonCoordinates());
      }

      if (polygon !== prevProps.polygon) {
        Polygon.updatePolygon(polygon, function () {
          return onPolygonEdit(Polygon.getPolygonCoordinates());
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          latitude = _this$props2.latitude,
          longitude = _this$props2.longitude,
          polygon = _this$props2.polygon,
          radius = _this$props2.radius,
          isBeingEdited = _this$props2.isBeingEdited,
          showMarker = _this$props2.showMarker,
          _onPolygonEdit = _this$props2.onPolygonEdit;
      return React__default["default"].createElement("div", {
        className: classes.map
      }, React__default["default"].createElement(_Map, {
        latitude: latitude,
        longitude: longitude,
        polygon: polygon,
        radius: radius,
        isBeingEdited: isBeingEdited,
        showMarker: showMarker,
        onPolygonEdit: function onPolygonEdit() {
          return _onPolygonEdit(Polygon.getPolygonCoordinates());
        }
      }));
    }
  }]);

  return ServiceAreaMap;
}(React.PureComponent)) || _class) || _class);
ServiceAreaMap.defaultProps = {
  polygon: [],
  radius: 10,
  isBeingEdited: false,
  showMarker: false,
  resetPolygonShape: false,
  onPolygonEdit: function onPolygonEdit() {},
  onRadiusChange: function onRadiusChange() {},
  onResetPolygonShape: function onResetPolygonShape() {}
};

module.exports = ServiceAreaMap;
